import * as React from 'react';
import { Space, Table, Icons } from 'procredit-bank-design-system';
import { useMediaQuery } from 'react-responsive';
import { useTranslation } from 'react-i18next';

const { EditTwoTone, DeleteTwoTone } = Icons;

const TransferTable = (props: any) => {
    const { data, removeTransfer, editTransfer, columns } = props;
    const isWebDevice = useMediaQuery({ query: '(min-width:1100px)' });
    const { t } = useTranslation();

    let tableColumns = [
        {
            title: 'Action',
            key: 'action',
            render: (text: any, record: any) => {
                return (
                    <Space size="middle">
                        <i onClick={() => editTransfer(record)} title="Edit"> <EditTwoTone style={{ cursor: 'pointer' }} /> </i>
                        <i onClick={() => removeTransfer(record.key)} title="Delete"> <DeleteTwoTone style={{ cursor: 'pointer' }} /> </i>
                    </Space>);
            }
        },
    ];

    const smallScreenColumn = [{
        key: 'transfer',
        title: 'Transfer',
        render: (record: any) => {
            return (
                Object.values(record).slice(1).map((e: any) => {
                    return (<React.Fragment>
                        {e} <br />
                    </React.Fragment>);
                })
            )
        },
        sorter: (a: any, b: any) => a.name.localeCompare(b.name),
        sortDirections: ['descend', 'ascend']
    },
    {
        title: 'Action',
        key: 'action',
        render: (text: any, record: any) => {
            return (
                <Space size="middle">
                    <i onClick={() => editTransfer(record)} title="Edit"> <EditTwoTone style={{ cursor: 'pointer' }} /> </i>
                    <i onClick={() => removeTransfer(record.key)} title="Delete"> <DeleteTwoTone style={{ cursor: 'pointer' }} /> </i>
                </Space>);
        },
    }];

    if (Array.isArray(columns)) {
        tableColumns = [...columns, ...tableColumns];
        tableColumns.forEach(c => c.title = t(c.key));
        smallScreenColumn.forEach(c => c.title = t(c.key));
    }

    return (
        <Table
            columns={isWebDevice ? tableColumns : smallScreenColumn}
            dataSource={data}
            pagination={{ hideOnSinglePage: true }}
        />)
};

export default TransferTable;